import * as React from "react";
import * as ReactDOM from "react-dom";
import { Html } from "../../../../components";
import { tl } from "../../../../utils";
import * as styles from "../../styles.scss";

const translator: any = (window as any).$.translator,
  locales: any = {
    skipped: translator.translate("Пропущен!"),
    noanswer: translator.translate("Не был дан ответ"),
  };

interface IFillProps {
  option: any;
}

export const Fill = (props: any) => {
  let i = 0;
  return (
    <div className={styles.answerBlock}>
      <span className={styles.answerTitleInline}>{tl("Ответ")}.</span>
      <Html>
        {props.question.description.replace(/##+/g, () => {
          if (props.value[i] === undefined) {
            return `<b>${locales.skipped}</b>`;
          }
          let option = props.value[i++].option;

          if (option.length === 0) {
            return `<b>${locales.skipped}</b>`;
          }

          return `<b>${option}</b>`;
        })}
      </Html>
    </div>
  );
};
